import styled from "styled-components/macro";
import { Text, Accordion, Button } from "@gcs/design-system/react";

export const ReportChannelSection = styled.section(
  ({ theme, $background }) => ({
    background: $background ? $background : theme.color.neutral["07"],
    paddingTop: "40px",
    paddingBottom: "40px",

    [theme.breakpoint.xl()]: {
      paddingTop: "60px",
      paddingBottom: "60px",
      flexDirection: "row",
    },
  }),
);

export const ReportChannelSectionContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",

  [theme.breakpoint.xl()]: {
    flexDirection: "row",
  },
}));

export const InfoContainer = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flexBasis: "50%",
  padding: 0,

  [theme.breakpoint.xl()]: {
    maxWidth: "730px",
    marginRight: "24px",
  },
}));

export const InfoContainer2 = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  flexBasis: "100%",
  [theme.breakpoint.xl()]: {
    marginLeft: "24px",
  },
}));

export const MainTitle = styled(Text)(({ theme }) => ({
  color: theme.color.brandPrimary.light,
  fontSize: "32px",
  paddingBottom: "32px",

  [theme.breakpoint.xl()]: {
    paddingBottom: "36px",
    fontSize: "40px",
  },
}));

export const MainDescription = styled(Text)(({ theme }) => ({
  color: theme.color.brandPrimary.dark,
  fontSize: "20px",
  lineHeight: "32px",
  fontWeight: "500",
  maxWidth: "530px",
}));

export const StyledAccordion = styled(Accordion)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  padding: "0 0 36px",
}));

export const StyledAccordionItem = styled(Accordion.Item)(({ theme }) => ({
  color: theme.color.neutral["02"],
  padding: "0 !important",
  fontSize: "16px",
  lineHeight: "24px",
  fontWeight: "500",
  p: {
    fontSize: "20px",
    lineHeight: "32px",
    color: theme.color.brandPrimary.light,
    fontWeight: "500",
  },
  strong: {
    fontWeight: "700",
    color: "#D70064",
    textDecoration: "underline",
  },
}));

export const ActionDescription = styled(Text)(({ theme }) => ({
  fontWeight: "500",
  lineHeight: "160%",
  marginBottom: "32px",
  padding: 0,
  fontSize: "18px",

  [theme.breakpoint.lg()]: {
    fontSize: "20px",
  },
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  fontWeight: "700",
  borderRadius: "8px",
  marginTop: "10px",
  fontSize: "16px",

  [theme.breakpoint.xl()]: {
    alignSelf: "flex-start",
  },
}));
